// extracted by mini-css-extract-plugin
export default {"Icon":"arrow-icon_Icon__2Yj3s"};